<template>
    <PatientHistory :Type="AppServiceID" />
</template>

<script>
import PatientHistory from '@/components/Common/PatientHistorySearch.vue'
import LayoutDefault from '@/Common/Default/DefaultLayout.vue';
export default {
    data: function (){
        return {
            AppServiceID :'',            
        }
    },
    components: {
        PatientHistory
    },
    created: function() {
        this.AppServiceID = this.$store.getters.GetOpticalID;
        this.$emit('update:layout', LayoutDefault);
    },    
    beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetOpticalID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetOpticalID);
    },
}
</script>

<style>

</style>
